import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.75 3.769v4.5m0-4.5h4.5m-4.5 0L9 9.019m-5.25 11.25v-4.5m0 4.5h4.5m-4.5 0L9 15.019m11.25-11.25h-4.5m4.5 0v4.5m0-4.5L15 9.019m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15.019"
    }, null, -1)
  ])))
}
export default { render: render }